import store from '@/store'

const configured = (to, from, next) => {
  const isCashRegisterConfigured = store.getters.isCashRegisterConfigured
  // check if cash register has been configured
  // prevent redirection loop to /settings
  if ((!isCashRegisterConfigured) && to.path !== '/settings') {
    if (from.path === '/settings') return
    return next('/settings')
  }

  next()
}
export default configured



// WEBPACK FOOTER //
// ./src/router/guards/configured.js